import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';

// Optional chaining so importing this module never throws when runtime config is absent (e.g. unit tests)
const connectionString = (window as any).app?.env?.CONNECTION_STRING;

const appInsights = new ApplicationInsights({
  config: {
    connectionString,
    enableAutoRouteTracking: true, // Automatically track route changes in SPAs
  },
});

// Telemetry must never break the app - all error reporting goes through this guard
export function safeTrackException(
  exception: unknown,
  properties: Record<string, any>,
  severityLevel?: SeverityLevel
) {
  try {
    appInsights.trackException({
      exception: exception instanceof Error ? exception : new Error(String(exception)),
      severityLevel,
      properties,
    });
  } catch {
    // ignored
  }
}

export default appInsights;
